/* tslint:disable */
/* eslint-disable */
/**
 * customerForecastManage API
 * 客先内示の情報を操作するやつ
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 客先内示情報
 * @export
 * @interface CustomerForecast
 */
export interface CustomerForecast {
    /**
     * 
     * @type {string}
     * @memberof CustomerForecast
     */
    'customerForecastId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerForecast
     */
    'customerForecastResponsibleUserIdHistory'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerForecast
     */
    'createdSupplierForecast': boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerForecast
     */
    'customerForecastReceivedYear': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerForecast
     */
    'customerForecastReceivedMonth': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerForecast
     */
    'customerForecastTargetYear': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerForecast
     */
    'customerForecastTargetMonth': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerForecast
     */
    'customerForecastAmount': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerForecast
     */
    'updateAt': number;
}
/**
 * 
 * @export
 * @interface CustomerForecastDataInner
 */
export interface CustomerForecastDataInner {
    /**
     * 関連取引ID
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'baseBusinessId'?: string;
    /**
     * 集計取引ID
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'aggregateBusinessId'?: string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof CustomerForecastDataInner
     */
    'baseBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 置場CD
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'warehouse': string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'supplierName': string;
    /**
     * 商品CD
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof CustomerForecastDataInner
     */
    'package': number;
    /**
     * 単位
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'manufacturer'?: string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'customerName': string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'salesDestinationName': string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'endUser'?: string;
    /**
     * 仕入先内示作成ステータス
     * @type {boolean}
     * @memberof CustomerForecastDataInner
     */
    'createdSupplierForecast': boolean;
    /**
     * 受領用内示名
     * @type {string}
     * @memberof CustomerForecastDataInner
     */
    'forecastForReceiptName'?: string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof CustomerForecastDataInner
     */
    'forecastForReceiptResponsibleUsers'?: Array<UserData>;
    /**
     * 客先内示の詳細情報
     * @type {Array<CustomerForecast>}
     * @memberof CustomerForecastDataInner
     */
    'customerAnnounces'?: Array<CustomerForecast>;
}
/**
 * 
 * @export
 * @interface CustomerForecastDiffLastMonthResponseDataInner
 */
export interface CustomerForecastDiffLastMonthResponseDataInner {
    /**
     * 関連取引ID
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'baseBusinessId': string;
    /**
     * 集計取引ID
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'aggregateBusinessId'?: string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'baseBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 仕入先名
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'supplierName': string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'supplierNumber': string;
    /**
     * 商品CD
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'businessName': string;
    /**
     * 容量
     * @type {number}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'package': number;
    /**
     * 単位
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'manufacturer'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'warehouse': string;
    /**
     * 置場CD
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'warehouseNumber': string;
    /**
     * 売上先名
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'customerName': string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'customerNumber': string;
    /**
     * 送り先名
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'salesDestinationName': string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'salesDestinationNumber': string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'endUser'?: string;
    /**
     * 客先内示の詳細情報
     * @type {Array<CustomerForecastWithDiffLastMonth>}
     * @memberof CustomerForecastDiffLastMonthResponseDataInner
     */
    'customerAnnounces': Array<CustomerForecastWithDiffLastMonth>;
}
/**
 * リクエストに含めるフィルター項目の型
 * @export
 * @interface CustomerForecastFilterItem
 */
export interface CustomerForecastFilterItem {
    /**
     * 集計取引ID
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'aggregateBusinessId'?: string;
    /**
     * 関連取引ID
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'baseBusinessId'?: string;
    /**
     * 関連取引担当者ID
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'baseBusienssResponsibleUserId'?: string;
    /**
     * 置場CD
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof CustomerForecastFilterItem
     */
    'package'?: number;
    /**
     * 単位
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'manufacturer'?: string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'customerName'?: string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'salesDestinationName'?: string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'endUser'?: string;
    /**
     * 受領用内示ID
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'forecastForReceiptId'?: string;
    /**
     * 受領用内示担当者ID
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'forecastForReceiptResponsibleUserId'?: string;
}
/**
 * 内示正答率データ
 * @export
 * @interface CustomerForecastRateDataItem
 */
export interface CustomerForecastRateDataItem {
    /**
     * 受領用内示ID
     * @type {string}
     * @memberof CustomerForecastRateDataItem
     */
    'forecastForReceiptId': string;
    /**
     * 受領用内示名
     * @type {string}
     * @memberof CustomerForecastRateDataItem
     */
    'forecastForReceiptName': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof CustomerForecastRateDataItem
     */
    'forecastForReceiptResponsibleUsers': Array<UserData>;
    /**
     * 前月販売実績
     * @type {number}
     * @memberof CustomerForecastRateDataItem
     */
    'previousMonthSalesResult': number;
    /**
     * 前月内示
     * @type {number}
     * @memberof CustomerForecastRateDataItem
     */
    'previousMonthForecast': number;
    /**
     * 月次精度データ
     * @type {Array<ForecastAccuracyMonthlyData>}
     * @memberof CustomerForecastRateDataItem
     */
    'monthlyAccuracy': Array<ForecastAccuracyMonthlyData>;
}
/**
 * リクエストに含めるフィルター項目の型
 * @export
 * @interface CustomerForecastTimelineFilterItem
 */
export interface CustomerForecastTimelineFilterItem {
    /**
     * 関連取引担当者ID
     * @type {string}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'baseBusinessResponsibleUserId'?: string;
    /**
     * 置場CD
     * @type {string}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'package'?: number;
    /**
     * 売上先CD
     * @type {string}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'customerName'?: string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof CustomerForecastTimelineFilterItem
     */
    'salesDestinationName'?: string;
}
/**
 * リクエストに含めるフィルター項目の型
 * @export
 * @interface CustomerForecastTimelineRequiredFilterItem
 */
export interface CustomerForecastTimelineRequiredFilterItem {
    /**
     * 関連取引担当者ID
     * @type {string}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'baseBusinessResponsibleUserId'?: string;
    /**
     * 置場CD
     * @type {string}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'warehouse': string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'supplierName': string;
    /**
     * 商品CD
     * @type {string}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'businessName': string;
    /**
     * 容量
     * @type {number}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'package': number;
    /**
     * 売上先CD
     * @type {string}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'customerNumber': string;
    /**
     * 売上先名
     * @type {string}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'customerName': string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'salesDestinationNumber': string;
    /**
     * 送り先名
     * @type {string}
     * @memberof CustomerForecastTimelineRequiredFilterItem
     */
    'salesDestinationName': string;
}
/**
 * 客先内示関連情報
 * @export
 * @interface CustomerForecastTimelineResponseData
 */
export interface CustomerForecastTimelineResponseData {
    /**
     * 関連取引ID
     * @type {string}
     * @memberof CustomerForecastTimelineResponseData
     */
    'baseBusinessId': string;
    /**
     * 客先内示の詳細情報
     * @type {Array<CustomerForecast>}
     * @memberof CustomerForecastTimelineResponseData
     */
    'customerForecasts': Array<CustomerForecast>;
    /**
     * 販売実績の詳細情報
     * @type {Array<SalesResult>}
     * @memberof CustomerForecastTimelineResponseData
     */
    'salesResults': Array<SalesResult>;
}
/**
 * 客先内示情報
 * @export
 * @interface CustomerForecastWithDiffLastMonth
 */
export interface CustomerForecastWithDiffLastMonth {
    /**
     * 
     * @type {string}
     * @memberof CustomerForecastWithDiffLastMonth
     */
    'customerForecastId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerForecastWithDiffLastMonth
     */
    'baseBusinessId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerForecastWithDiffLastMonth
     */
    'customerForecastReceivedYear': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerForecastWithDiffLastMonth
     */
    'customerForecastReceivedMonth': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerForecastWithDiffLastMonth
     */
    'customerForecastTargetYear': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerForecastWithDiffLastMonth
     */
    'customerForecastTargetMonth': number;
    /**
     * 対象年月の前月の客先内示数量
     * @type {number}
     * @memberof CustomerForecastWithDiffLastMonth
     */
    'amountLastMonth'?: number;
    /**
     * 対象年月の客先内示数量
     * @type {number}
     * @memberof CustomerForecastWithDiffLastMonth
     */
    'amountTargetMonth': number;
    /**
     * 対象年月と前月との数量の差異
     * @type {number}
     * @memberof CustomerForecastWithDiffLastMonth
     */
    'amountDiffValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerForecastWithDiffLastMonth
     */
    'updateAt'?: number;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 
 * @export
 * @interface ExportCustomerForecastRateRequest
 */
export interface ExportCustomerForecastRateRequest {
    /**
     * 受領用内示ID
     * @type {string}
     * @memberof ExportCustomerForecastRateRequest
     */
    'forecastForReceiptId': string;
    /**
     * 開始年
     * @type {number}
     * @memberof ExportCustomerForecastRateRequest
     */
    'startYear': number;
    /**
     * 開始月
     * @type {number}
     * @memberof ExportCustomerForecastRateRequest
     */
    'startMonth': number;
    /**
     * 終了年
     * @type {number}
     * @memberof ExportCustomerForecastRateRequest
     */
    'endYear': number;
    /**
     * 終了月
     * @type {number}
     * @memberof ExportCustomerForecastRateRequest
     */
    'endMonth': number;
    /**
     * 内示受領年
     * @type {number}
     * @memberof ExportCustomerForecastRateRequest
     */
    'receiveYear': number;
    /**
     * 内示受領月
     * @type {number}
     * @memberof ExportCustomerForecastRateRequest
     */
    'receiveMonth': number;
    /**
     * 出力言語（ja: 日本語、en: 英語）
     * @type {string}
     * @memberof ExportCustomerForecastRateRequest
     */
    'language': ExportCustomerForecastRateRequestLanguageEnum;
}

export const ExportCustomerForecastRateRequestLanguageEnum = {
    Ja: 'ja',
    En: 'en'
} as const;

export type ExportCustomerForecastRateRequestLanguageEnum = typeof ExportCustomerForecastRateRequestLanguageEnum[keyof typeof ExportCustomerForecastRateRequestLanguageEnum];

/**
 * 内示正答率エクスポートのレスポンス
 * @export
 * @interface ExportCustomerForecastRateResponse
 */
export interface ExportCustomerForecastRateResponse {
    /**
     * 
     * @type {number}
     * @memberof ExportCustomerForecastRateResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof ExportCustomerForecastRateResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ExportCustomerForecastRateResponse
     */
    'message': string;
    /**
     * 
     * @type {ExportCustomerForecastRateResponseAllOfResult}
     * @memberof ExportCustomerForecastRateResponse
     */
    'result': ExportCustomerForecastRateResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface ExportCustomerForecastRateResponseAllOfResult
 */
export interface ExportCustomerForecastRateResponseAllOfResult {
    /**
     * ダウンロードURL
     * @type {string}
     * @memberof ExportCustomerForecastRateResponseAllOfResult
     */
    'download_url': string;
    /**
     * ファイル名
     * @type {string}
     * @memberof ExportCustomerForecastRateResponseAllOfResult
     */
    'file_name': string;
}
/**
 * 
 * @export
 * @interface ExportCustomerForecastRequest
 */
export interface ExportCustomerForecastRequest {
    /**
     * 開始年
     * @type {number}
     * @memberof ExportCustomerForecastRequest
     */
    'startYear': number;
    /**
     * 開始月
     * @type {number}
     * @memberof ExportCustomerForecastRequest
     */
    'startMonth': number;
    /**
     * 終了年
     * @type {number}
     * @memberof ExportCustomerForecastRequest
     */
    'endYear': number;
    /**
     * 終了月
     * @type {number}
     * @memberof ExportCustomerForecastRequest
     */
    'endMonth': number;
    /**
     * 内示受領年
     * @type {number}
     * @memberof ExportCustomerForecastRequest
     */
    'receivedYear': number;
    /**
     * 内示受領月
     * @type {number}
     * @memberof ExportCustomerForecastRequest
     */
    'receivedMonth': number;
    /**
     * 出力言語（ja: 日本語、en: 英語）
     * @type {string}
     * @memberof ExportCustomerForecastRequest
     */
    'language': ExportCustomerForecastRequestLanguageEnum;
    /**
     * 
     * @type {CustomerForecastFilterItem}
     * @memberof ExportCustomerForecastRequest
     */
    'filterItem'?: CustomerForecastFilterItem;
}

export const ExportCustomerForecastRequestLanguageEnum = {
    Ja: 'ja',
    En: 'en'
} as const;

export type ExportCustomerForecastRequestLanguageEnum = typeof ExportCustomerForecastRequestLanguageEnum[keyof typeof ExportCustomerForecastRequestLanguageEnum];

/**
 * 客先内示エクスポートのレスポンス
 * @export
 * @interface ExportCustomerForecastResponse
 */
export interface ExportCustomerForecastResponse {
    /**
     * 
     * @type {number}
     * @memberof ExportCustomerForecastResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof ExportCustomerForecastResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ExportCustomerForecastResponse
     */
    'message': string;
    /**
     * 
     * @type {ExportCustomerForecastRateResponseAllOfResult}
     * @memberof ExportCustomerForecastResponse
     */
    'result': ExportCustomerForecastRateResponseAllOfResult;
}
/**
 * 関連取引IDに紐づくフィルタ情報
 * @export
 * @interface FilterItemsForCustomerForecastTimelineResponseData
 */
export interface FilterItemsForCustomerForecastTimelineResponseData {
    /**
     * 関連取引ID
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'baseBusinessId': string;
    /**
     * 集計取引ID
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'aggregateBusinessId': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'baseBusinessResponsibleUsers': Array<UserData>;
    /**
     * 置場CD
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'warehouse': string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'supplierName': string;
    /**
     * 商品CD
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'businessName': string;
    /**
     * 容量
     * @type {number}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'package': number;
    /**
     * 売上先CD
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'customerNumber': string;
    /**
     * 売上先名
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'customerName': string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'salesDestinationNumber': string;
    /**
     * 送り先名
     * @type {string}
     * @memberof FilterItemsForCustomerForecastTimelineResponseData
     */
    'salesDestinationName': string;
}
/**
 * 月次内示正答率データ
 * @export
 * @interface ForecastAccuracyMonthlyData
 */
export interface ForecastAccuracyMonthlyData {
    /**
     * 対象年
     * @type {number}
     * @memberof ForecastAccuracyMonthlyData
     */
    'targetYear': number;
    /**
     * 対象月
     * @type {number}
     * @memberof ForecastAccuracyMonthlyData
     */
    'targetMonth': number;
    /**
     * 精度率（整数、nullの場合は\"-\"を表示）
     * @type {number}
     * @memberof ForecastAccuracyMonthlyData
     */
    'accuracyRate': number | null;
}
/**
 * 関連取引ID取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetBaseBusinessIdResponse
 */
export interface GetBaseBusinessIdResponse {
    /**
     * 
     * @type {number}
     * @memberof GetBaseBusinessIdResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetBaseBusinessIdResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetBaseBusinessIdResponse
     */
    'message': string;
    /**
     * 
     * @type {GetBaseBusinessIdResponseAllOfResult}
     * @memberof GetBaseBusinessIdResponse
     */
    'result': GetBaseBusinessIdResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetBaseBusinessIdResponseAllOfResult
 */
export interface GetBaseBusinessIdResponseAllOfResult {
    /**
     * 
     * @type {GetBaseBusinessIdResponseAllOfResultData}
     * @memberof GetBaseBusinessIdResponseAllOfResult
     */
    'data': GetBaseBusinessIdResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetBaseBusinessIdResponseAllOfResultData
 */
export interface GetBaseBusinessIdResponseAllOfResultData {
    /**
     * 
     * @type {string}
     * @memberof GetBaseBusinessIdResponseAllOfResultData
     */
    'baseBusinessId': string;
}
/**
 * 商品名取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetBusinessNameResponse
 */
export interface GetBusinessNameResponse {
    /**
     * 
     * @type {number}
     * @memberof GetBusinessNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetBusinessNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetBusinessNameResponse
     */
    'message': string;
    /**
     * 
     * @type {GetBusinessNameResponseAllOfResult}
     * @memberof GetBusinessNameResponse
     */
    'result': GetBusinessNameResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetBusinessNameResponseAllOfResult
 */
export interface GetBusinessNameResponseAllOfResult {
    /**
     * 
     * @type {GetBusinessNameResponseAllOfResultData}
     * @memberof GetBusinessNameResponseAllOfResult
     */
    'data': GetBusinessNameResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetBusinessNameResponseAllOfResultData
 */
export interface GetBusinessNameResponseAllOfResultData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBusinessNameResponseAllOfResultData
     */
    'businessNameList': Array<string>;
}
/**
 * 商品CD取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetBusinessNumberResponse
 */
export interface GetBusinessNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof GetBusinessNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetBusinessNumberResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetBusinessNumberResponse
     */
    'message': string;
    /**
     * 
     * @type {GetBusinessNumberResponseAllOfResult}
     * @memberof GetBusinessNumberResponse
     */
    'result': GetBusinessNumberResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetBusinessNumberResponseAllOfResult
 */
export interface GetBusinessNumberResponseAllOfResult {
    /**
     * 
     * @type {GetBusinessNumberResponseAllOfResultData}
     * @memberof GetBusinessNumberResponseAllOfResult
     */
    'data': GetBusinessNumberResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetBusinessNumberResponseAllOfResultData
 */
export interface GetBusinessNumberResponseAllOfResultData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBusinessNumberResponseAllOfResultData
     */
    'businessNumberList': Array<string>;
}
/**
 * 客先内示前月差異の一覧を返すレスポンス
 * @export
 * @interface GetCustomerForecastDiffLastMonthResponse
 */
export interface GetCustomerForecastDiffLastMonthResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCustomerForecastDiffLastMonthResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerForecastDiffLastMonthResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerForecastDiffLastMonthResponse
     */
    'message': string;
    /**
     * 
     * @type {GetCustomerForecastDiffLastMonthResponseAllOfResult}
     * @memberof GetCustomerForecastDiffLastMonthResponse
     */
    'result': GetCustomerForecastDiffLastMonthResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetCustomerForecastDiffLastMonthResponseAllOfResult
 */
export interface GetCustomerForecastDiffLastMonthResponseAllOfResult {
    /**
     * 客先内示関連情報
     * @type {Array<CustomerForecastDiffLastMonthResponseDataInner>}
     * @memberof GetCustomerForecastDiffLastMonthResponseAllOfResult
     */
    'data': Array<CustomerForecastDiffLastMonthResponseDataInner>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetCustomerForecastDiffLastMonthResponseAllOfResult
     */
    'pagingOptions': PagingOptions;
}
/**
 * 内示正答率情報の一覧を返すレスポンス
 * @export
 * @interface GetCustomerForecastRateResponse
 */
export interface GetCustomerForecastRateResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCustomerForecastRateResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerForecastRateResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerForecastRateResponse
     */
    'message': string;
    /**
     * 
     * @type {GetCustomerForecastRateResponseAllOfResult}
     * @memberof GetCustomerForecastRateResponse
     */
    'result': GetCustomerForecastRateResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetCustomerForecastRateResponseAllOfResult
 */
export interface GetCustomerForecastRateResponseAllOfResult {
    /**
     * 内示正答率データの配列
     * @type {Array<CustomerForecastRateDataItem>}
     * @memberof GetCustomerForecastRateResponseAllOfResult
     */
    'data': Array<CustomerForecastRateDataItem>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetCustomerForecastRateResponseAllOfResult
     */
    'pagingOptions': PagingOptions;
}
/**
 * 客先内示の一覧を返すレスポンス
 * @export
 * @interface GetCustomerForecastResponse
 */
export interface GetCustomerForecastResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCustomerForecastResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerForecastResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerForecastResponse
     */
    'message': string;
    /**
     * 
     * @type {GetCustomerForecastResponseAllOfResult}
     * @memberof GetCustomerForecastResponse
     */
    'result': GetCustomerForecastResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetCustomerForecastResponseAllOfResult
 */
export interface GetCustomerForecastResponseAllOfResult {
    /**
     * 客先内示関連情報
     * @type {Array<CustomerForecastDataInner>}
     * @memberof GetCustomerForecastResponseAllOfResult
     */
    'data': Array<CustomerForecastDataInner>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetCustomerForecastResponseAllOfResult
     */
    'pagingOptions': PagingOptions;
}
/**
 * 客先内示遍歴の一覧を返すレスポンス
 * @export
 * @interface GetCustomerForecastTimelineResponse
 */
export interface GetCustomerForecastTimelineResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCustomerForecastTimelineResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerForecastTimelineResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerForecastTimelineResponse
     */
    'message': string;
    /**
     * 
     * @type {GetCustomerForecastTimelineResponseAllOfResult}
     * @memberof GetCustomerForecastTimelineResponse
     */
    'result': GetCustomerForecastTimelineResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetCustomerForecastTimelineResponseAllOfResult
 */
export interface GetCustomerForecastTimelineResponseAllOfResult {
    /**
     * 
     * @type {CustomerForecastTimelineResponseData}
     * @memberof GetCustomerForecastTimelineResponseAllOfResult
     */
    'data': CustomerForecastTimelineResponseData;
}
/**
 * 売上先名取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetCustomerNameResponse
 */
export interface GetCustomerNameResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCustomerNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerNameResponse
     */
    'message': string;
    /**
     * 
     * @type {GetCustomerNameResponseAllOfResult}
     * @memberof GetCustomerNameResponse
     */
    'result': GetCustomerNameResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetCustomerNameResponseAllOfResult
 */
export interface GetCustomerNameResponseAllOfResult {
    /**
     * 
     * @type {GetCustomerNameResponseAllOfResultData}
     * @memberof GetCustomerNameResponseAllOfResult
     */
    'data': GetCustomerNameResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetCustomerNameResponseAllOfResultData
 */
export interface GetCustomerNameResponseAllOfResultData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerNameResponseAllOfResultData
     */
    'customerNameList': Array<string>;
}
/**
 * 売上先CD取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetCustomerNumberResponse
 */
export interface GetCustomerNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCustomerNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerNumberResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerNumberResponse
     */
    'message': string;
    /**
     * 
     * @type {GetCustomerNumberResponseAllOfResult}
     * @memberof GetCustomerNumberResponse
     */
    'result': GetCustomerNumberResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetCustomerNumberResponseAllOfResult
 */
export interface GetCustomerNumberResponseAllOfResult {
    /**
     * 
     * @type {GetCustomerNumberResponseAllOfResultData}
     * @memberof GetCustomerNumberResponseAllOfResult
     */
    'data': GetCustomerNumberResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetCustomerNumberResponseAllOfResultData
 */
export interface GetCustomerNumberResponseAllOfResultData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerNumberResponseAllOfResultData
     */
    'customerNumberList': Array<string>;
}
/**
 * 関連取引IDに紐づくフィルタ情報取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetFilterItemsForCustomerForecastTimelineResponse
 */
export interface GetFilterItemsForCustomerForecastTimelineResponse {
    /**
     * 
     * @type {number}
     * @memberof GetFilterItemsForCustomerForecastTimelineResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetFilterItemsForCustomerForecastTimelineResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetFilterItemsForCustomerForecastTimelineResponse
     */
    'message': string;
    /**
     * 
     * @type {GetFilterItemsForCustomerForecastTimelineResponseAllOfResult}
     * @memberof GetFilterItemsForCustomerForecastTimelineResponse
     */
    'result': GetFilterItemsForCustomerForecastTimelineResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetFilterItemsForCustomerForecastTimelineResponseAllOfResult
 */
export interface GetFilterItemsForCustomerForecastTimelineResponseAllOfResult {
    /**
     * 
     * @type {FilterItemsForCustomerForecastTimelineResponseData}
     * @memberof GetFilterItemsForCustomerForecastTimelineResponseAllOfResult
     */
    'data': FilterItemsForCustomerForecastTimelineResponseData;
}
/**
 * 指定した期間の客先内示を返すレスポンス
 * @export
 * @interface GetLongTermCustomerForecastResponse
 */
export interface GetLongTermCustomerForecastResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLongTermCustomerForecastResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetLongTermCustomerForecastResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetLongTermCustomerForecastResponse
     */
    'message': string;
    /**
     * 
     * @type {GetLongTermCustomerForecastResponseAllOfResult}
     * @memberof GetLongTermCustomerForecastResponse
     */
    'result': GetLongTermCustomerForecastResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetLongTermCustomerForecastResponseAllOfResult
 */
export interface GetLongTermCustomerForecastResponseAllOfResult {
    /**
     * 指定した期間の客先内示サマリ関連情報
     * @type {Array<CustomerForecast>}
     * @memberof GetLongTermCustomerForecastResponseAllOfResult
     */
    'data': Array<CustomerForecast>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetLongTermCustomerForecastResponseAllOfResult
     */
    'pagingOptions': PagingOptions;
}
/**
 * 容量取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetPackageResponse
 */
export interface GetPackageResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPackageResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetPackageResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetPackageResponse
     */
    'message': string;
    /**
     * 
     * @type {GetPackageResponseAllOfResult}
     * @memberof GetPackageResponse
     */
    'result': GetPackageResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetPackageResponseAllOfResult
 */
export interface GetPackageResponseAllOfResult {
    /**
     * 
     * @type {GetPackageResponseAllOfResultData}
     * @memberof GetPackageResponseAllOfResult
     */
    'data': GetPackageResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetPackageResponseAllOfResultData
 */
export interface GetPackageResponseAllOfResultData {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPackageResponseAllOfResultData
     */
    'packageList': Array<number>;
}
/**
 * 送り先名取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetSalesDestinationNameResponse
 */
export interface GetSalesDestinationNameResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSalesDestinationNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetSalesDestinationNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetSalesDestinationNameResponse
     */
    'message': string;
    /**
     * 
     * @type {GetSalesDestinationNameResponseAllOfResult}
     * @memberof GetSalesDestinationNameResponse
     */
    'result': GetSalesDestinationNameResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetSalesDestinationNameResponseAllOfResult
 */
export interface GetSalesDestinationNameResponseAllOfResult {
    /**
     * 
     * @type {GetSalesDestinationNameResponseAllOfResultData}
     * @memberof GetSalesDestinationNameResponseAllOfResult
     */
    'data': GetSalesDestinationNameResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetSalesDestinationNameResponseAllOfResultData
 */
export interface GetSalesDestinationNameResponseAllOfResultData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSalesDestinationNameResponseAllOfResultData
     */
    'salesDestinationNameList': Array<string>;
}
/**
 * 送り先CD取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetSalesDestinationNumberResponse
 */
export interface GetSalesDestinationNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSalesDestinationNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetSalesDestinationNumberResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetSalesDestinationNumberResponse
     */
    'message': string;
    /**
     * 
     * @type {GetSalesDestinationNumberResponseAllOfResult}
     * @memberof GetSalesDestinationNumberResponse
     */
    'result': GetSalesDestinationNumberResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetSalesDestinationNumberResponseAllOfResult
 */
export interface GetSalesDestinationNumberResponseAllOfResult {
    /**
     * 
     * @type {GetSalesDestinationNumberResponseAllOfResultData}
     * @memberof GetSalesDestinationNumberResponseAllOfResult
     */
    'data': GetSalesDestinationNumberResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetSalesDestinationNumberResponseAllOfResultData
 */
export interface GetSalesDestinationNumberResponseAllOfResultData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSalesDestinationNumberResponseAllOfResultData
     */
    'salesDestinationNumberList': Array<string>;
}
/**
 * 仕入先名取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetSupplierNameResponse
 */
export interface GetSupplierNameResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSupplierNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetSupplierNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetSupplierNameResponse
     */
    'message': string;
    /**
     * 
     * @type {GetSupplierNameResponseAllOfResult}
     * @memberof GetSupplierNameResponse
     */
    'result': GetSupplierNameResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetSupplierNameResponseAllOfResult
 */
export interface GetSupplierNameResponseAllOfResult {
    /**
     * 
     * @type {GetSupplierNameResponseAllOfResultData}
     * @memberof GetSupplierNameResponseAllOfResult
     */
    'data': GetSupplierNameResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetSupplierNameResponseAllOfResultData
 */
export interface GetSupplierNameResponseAllOfResultData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSupplierNameResponseAllOfResultData
     */
    'supplierNameList': Array<string>;
}
/**
 * 仕入先CD取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetSupplierNumberResponse
 */
export interface GetSupplierNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSupplierNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetSupplierNumberResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetSupplierNumberResponse
     */
    'message': string;
    /**
     * 
     * @type {GetSupplierNumberResponseAllOfResult}
     * @memberof GetSupplierNumberResponse
     */
    'result': GetSupplierNumberResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetSupplierNumberResponseAllOfResult
 */
export interface GetSupplierNumberResponseAllOfResult {
    /**
     * 
     * @type {GetSupplierNumberResponseAllOfResultData}
     * @memberof GetSupplierNumberResponseAllOfResult
     */
    'data': GetSupplierNumberResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetSupplierNumberResponseAllOfResultData
 */
export interface GetSupplierNumberResponseAllOfResultData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSupplierNumberResponseAllOfResultData
     */
    'supplierNumberList': Array<string>;
}
/**
 * 担当者名取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetUserNameResponse
 */
export interface GetUserNameResponse {
    /**
     * 
     * @type {number}
     * @memberof GetUserNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetUserNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetUserNameResponse
     */
    'message': string;
    /**
     * 
     * @type {GetUserNameResponseAllOfResult}
     * @memberof GetUserNameResponse
     */
    'result': GetUserNameResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetUserNameResponseAllOfResult
 */
export interface GetUserNameResponseAllOfResult {
    /**
     * 
     * @type {GetUserNameResponseAllOfResultData}
     * @memberof GetUserNameResponseAllOfResult
     */
    'data': GetUserNameResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetUserNameResponseAllOfResultData
 */
export interface GetUserNameResponseAllOfResultData {
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof GetUserNameResponseAllOfResultData
     */
    'baseBusinessResponsibleUsers': Array<UserData>;
}
/**
 * 置場CD取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetWarehouseNumberResponse
 */
export interface GetWarehouseNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof GetWarehouseNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetWarehouseNumberResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetWarehouseNumberResponse
     */
    'message': string;
    /**
     * 
     * @type {GetWarehouseNumberResponseAllOfResult}
     * @memberof GetWarehouseNumberResponse
     */
    'result': GetWarehouseNumberResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetWarehouseNumberResponseAllOfResult
 */
export interface GetWarehouseNumberResponseAllOfResult {
    /**
     * 
     * @type {GetWarehouseNumberResponseAllOfResultData}
     * @memberof GetWarehouseNumberResponseAllOfResult
     */
    'data': GetWarehouseNumberResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetWarehouseNumberResponseAllOfResultData
 */
export interface GetWarehouseNumberResponseAllOfResultData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetWarehouseNumberResponseAllOfResultData
     */
    'warehouseNumberList': Array<string>;
}
/**
 * 置場名取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetWarehouseResponse
 */
export interface GetWarehouseResponse {
    /**
     * 
     * @type {number}
     * @memberof GetWarehouseResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetWarehouseResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetWarehouseResponse
     */
    'message': string;
    /**
     * 
     * @type {GetWarehouseResponseAllOfResult}
     * @memberof GetWarehouseResponse
     */
    'result': GetWarehouseResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetWarehouseResponseAllOfResult
 */
export interface GetWarehouseResponseAllOfResult {
    /**
     * 
     * @type {GetWarehouseResponseAllOfResultData}
     * @memberof GetWarehouseResponseAllOfResult
     */
    'data': GetWarehouseResponseAllOfResultData;
}
/**
 * 
 * @export
 * @interface GetWarehouseResponseAllOfResultData
 */
export interface GetWarehouseResponseAllOfResultData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetWarehouseResponseAllOfResultData
     */
    'warehouseList': Array<string>;
}
/**
 * APIから受け取るpagingOptionsの情報
 * @export
 * @interface PagingOptions
 */
export interface PagingOptions {
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'nextOffset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'totalResultsAvailable': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'returnCount': number;
}
/**
 * 
 * @export
 * @interface PostCustomerForecastRequest
 */
export interface PostCustomerForecastRequest {
    /**
     * 
     * @type {PostCustomerForecastRequestInfo}
     * @memberof PostCustomerForecastRequest
     */
    'postCustomerForecastInfo'?: PostCustomerForecastRequestInfo;
}
/**
 * 関連取引登録で投げる関連取引情報
 * @export
 * @interface PostCustomerForecastRequestInfo
 */
export interface PostCustomerForecastRequestInfo {
    /**
     * 
     * @type {string}
     * @memberof PostCustomerForecastRequestInfo
     */
    'baseBusinessId': string;
    /**
     * 
     * @type {number}
     * @memberof PostCustomerForecastRequestInfo
     */
    'customerForecastReceiveYear': number;
    /**
     * 
     * @type {number}
     * @memberof PostCustomerForecastRequestInfo
     */
    'customerForecastReceiveMonth': number;
    /**
     * 
     * @type {number}
     * @memberof PostCustomerForecastRequestInfo
     */
    'customerForecastTargetYear': number;
    /**
     * 
     * @type {number}
     * @memberof PostCustomerForecastRequestInfo
     */
    'customerForecastTargetMonth': number;
    /**
     * 
     * @type {number}
     * @memberof PostCustomerForecastRequestInfo
     */
    'customerForecastAmount': number;
}
/**
 * postした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface PostCustomerForecastResponse
 */
export interface PostCustomerForecastResponse {
    /**
     * 
     * @type {number}
     * @memberof PostCustomerForecastResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostCustomerForecastResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostCustomerForecastResponse
     */
    'message': string;
    /**
     * 
     * @type {PostCustomerForecastResponseResult}
     * @memberof PostCustomerForecastResponse
     */
    'result': PostCustomerForecastResponseResult;
}
/**
 * 関連取引登録APIのレスポンスの型定義
 * @export
 * @interface PostCustomerForecastResponseResult
 */
export interface PostCustomerForecastResponseResult {
    /**
     * 
     * @type {string}
     * @memberof PostCustomerForecastResponseResult
     */
    'customerForecastId'?: string;
}
/**
 * 販売実績情報
 * @export
 * @interface SalesResult
 */
export interface SalesResult {
    /**
     * 
     * @type {string}
     * @memberof SalesResult
     */
    'salesResultId': string;
    /**
     * 
     * @type {number}
     * @memberof SalesResult
     */
    'salesResultTargetYear': number;
    /**
     * 
     * @type {number}
     * @memberof SalesResult
     */
    'salesResultTargetMonth': number;
    /**
     * 
     * @type {number}
     * @memberof SalesResult
     */
    'salesResultAmount': number;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * ユーザーデータ
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'name'?: string;
}

/**
 * CustomerForecastApi - axios parameter creator
 * @export
 */
export const CustomerForecastApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 商品名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetBusinessNameForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/business-name/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 商品CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetBusinessNumberForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/business-number/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 売上先名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetCustomerNameForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/customer-name/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 売上先CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetCustomerNumberForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/customer-number/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 容量の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetPackageForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/package/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 送り先名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSalesDestinationNameForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/sales-destination-name/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 送り先CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSalesDestinationNumberForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/sales-destination-number/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 仕入先名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSupplierNameForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/supplier-name/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 仕入先CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSupplierNumberForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/supplier-number/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 担当者名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetUserNameForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/staff-id/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 置場名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetWarehouseForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/warehouse/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 置場CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetWarehouseNumberForCustomerForecastTimeline: async (otherFilterItems?: CustomerForecastTimelineFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-forecast/timeline/warehouse-number/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (otherFilterItems !== undefined) {
                for (const [key, value] of Object.entries(otherFilterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 客先内示情報をエクスポートする
         * @param {ExportCustomerForecastRequest} exportCustomerForecastRequest エクスポートする客先内示情報のリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCustomerForecast: async (exportCustomerForecastRequest: ExportCustomerForecastRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportCustomerForecastRequest' is not null or undefined
            assertParamExists('exportCustomerForecast', 'exportCustomerForecastRequest', exportCustomerForecastRequest)
            const localVarPath = `/customer-forecast/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportCustomerForecastRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 内示正答率情報をエクスポートする
         * @param {ExportCustomerForecastRateRequest} exportCustomerForecastRateRequest エクスポートする内示正答率情報のリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCustomerForecastRate: async (exportCustomerForecastRateRequest: ExportCustomerForecastRateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportCustomerForecastRateRequest' is not null or undefined
            assertParamExists('exportCustomerForecastRate', 'exportCustomerForecastRateRequest', exportCustomerForecastRateRequest)
            const localVarPath = `/customer-forecast/rate/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportCustomerForecastRateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 一意な関連取引IDをフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineRequiredFilterItem} filterItems フィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseBusinessIdForCustomerForecastTimeline: async (filterItems: CustomerForecastTimelineRequiredFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterItems' is not null or undefined
            assertParamExists('getBaseBusinessIdForCustomerForecastTimeline', 'filterItems', filterItems)
            const localVarPath = `/customer-forecast/timeline/base-business-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterItems !== undefined) {
                for (const [key, value] of Object.entries(filterItems)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 客先内示情報テーブルから情報の取得を行う
         * @param {GetCustomerForecastSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} receiveYear 客先内示受領年
         * @param {number} receiveMonth 客先内示受領月
         * @param {CustomerForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
         * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerForecast: async (sortType: GetCustomerForecastSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, filterItem?: CustomerForecastFilterItem, unassignedResponsibleUserFlag?: boolean, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getCustomerForecast', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getCustomerForecast', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getCustomerForecast', 'offset', offset)
            // verify required parameter 'receiveYear' is not null or undefined
            assertParamExists('getCustomerForecast', 'receiveYear', receiveYear)
            // verify required parameter 'receiveMonth' is not null or undefined
            assertParamExists('getCustomerForecast', 'receiveMonth', receiveMonth)
            const localVarPath = `/customer-forecast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (receiveYear !== undefined) {
                localVarQueryParameter['receive-year'] = receiveYear;
            }

            if (receiveMonth !== undefined) {
                localVarQueryParameter['receive-month'] = receiveMonth;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (unassignedResponsibleUserFlag !== undefined) {
                localVarQueryParameter['unassigned-responsible-user-flag'] = unassignedResponsibleUserFlag;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sort_target'] = sortTarget;
            }

            if (sortTargetYear !== undefined) {
                localVarQueryParameter['sort_target_year'] = sortTargetYear;
            }

            if (sortTargetMonth !== undefined) {
                localVarQueryParameter['sort_target_month'] = sortTargetMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 内示前月差異情報を取得する
         * @param {GetCustomerForecastDiffLastMonthSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} receiveYear 客先内示受領年
         * @param {number} receiveMonth 客先内示受領月
         * @param {CustomerForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
         * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerForecastDiffLastMonth: async (sortType: GetCustomerForecastDiffLastMonthSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, filterItem?: CustomerForecastFilterItem, unassignedResponsibleUserFlag?: boolean, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getCustomerForecastDiffLastMonth', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getCustomerForecastDiffLastMonth', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getCustomerForecastDiffLastMonth', 'offset', offset)
            // verify required parameter 'receiveYear' is not null or undefined
            assertParamExists('getCustomerForecastDiffLastMonth', 'receiveYear', receiveYear)
            // verify required parameter 'receiveMonth' is not null or undefined
            assertParamExists('getCustomerForecastDiffLastMonth', 'receiveMonth', receiveMonth)
            const localVarPath = `/customer-forecast/diff-last-month`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (receiveYear !== undefined) {
                localVarQueryParameter['receive-year'] = receiveYear;
            }

            if (receiveMonth !== undefined) {
                localVarQueryParameter['receive-month'] = receiveMonth;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (unassignedResponsibleUserFlag !== undefined) {
                localVarQueryParameter['unassigned-responsible-user-flag'] = unassignedResponsibleUserFlag;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sort_target'] = sortTarget;
            }

            if (sortTargetYear !== undefined) {
                localVarQueryParameter['sort_target_year'] = sortTargetYear;
            }

            if (sortTargetMonth !== undefined) {
                localVarQueryParameter['sort_target_month'] = sortTargetMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 内示正答率情報を取得する
         * @param {GetCustomerForecastRateSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} receiveYear 客先内示受領年
         * @param {number} receiveMonth 客先内示受領月
         * @param {number} displayMonths 表示月数（3-24の範囲）
         * @param {string} [forecastForReceiptResponsibleUserId] 受領用内示担当者ID
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
         * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerForecastRate: async (sortType: GetCustomerForecastRateSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, displayMonths: number, forecastForReceiptResponsibleUserId?: string, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getCustomerForecastRate', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getCustomerForecastRate', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getCustomerForecastRate', 'offset', offset)
            // verify required parameter 'receiveYear' is not null or undefined
            assertParamExists('getCustomerForecastRate', 'receiveYear', receiveYear)
            // verify required parameter 'receiveMonth' is not null or undefined
            assertParamExists('getCustomerForecastRate', 'receiveMonth', receiveMonth)
            // verify required parameter 'displayMonths' is not null or undefined
            assertParamExists('getCustomerForecastRate', 'displayMonths', displayMonths)
            const localVarPath = `/customer-forecast/rate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (receiveYear !== undefined) {
                localVarQueryParameter['receive-year'] = receiveYear;
            }

            if (receiveMonth !== undefined) {
                localVarQueryParameter['receive-month'] = receiveMonth;
            }

            if (displayMonths !== undefined) {
                localVarQueryParameter['display-months'] = displayMonths;
            }

            if (forecastForReceiptResponsibleUserId !== undefined) {
                localVarQueryParameter['forecastForReceiptResponsibleUserId'] = forecastForReceiptResponsibleUserId;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sort_target'] = sortTarget;
            }

            if (sortTargetYear !== undefined) {
                localVarQueryParameter['sort_target_year'] = sortTargetYear;
            }

            if (sortTargetMonth !== undefined) {
                localVarQueryParameter['sort_target_month'] = sortTargetMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 客先内示遍歴の情報を取得する
         * @param {string} baseBusinessId 関連取引ID
         * @param {number} startYear 表示開始年
         * @param {number} startMonth 表示開始月
         * @param {number} rangeMonth 表示する月の範囲
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerForecastTimeline: async (baseBusinessId: string, startYear: number, startMonth: number, rangeMonth: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseBusinessId' is not null or undefined
            assertParamExists('getCustomerForecastTimeline', 'baseBusinessId', baseBusinessId)
            // verify required parameter 'startYear' is not null or undefined
            assertParamExists('getCustomerForecastTimeline', 'startYear', startYear)
            // verify required parameter 'startMonth' is not null or undefined
            assertParamExists('getCustomerForecastTimeline', 'startMonth', startMonth)
            // verify required parameter 'rangeMonth' is not null or undefined
            assertParamExists('getCustomerForecastTimeline', 'rangeMonth', rangeMonth)
            const localVarPath = `/customer-forecast/timeline/{base_business_id}`
                .replace(`{${"base_business_id"}}`, encodeURIComponent(String(baseBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startYear !== undefined) {
                localVarQueryParameter['start-year'] = startYear;
            }

            if (startMonth !== undefined) {
                localVarQueryParameter['start-month'] = startMonth;
            }

            if (rangeMonth !== undefined) {
                localVarQueryParameter['range-month'] = rangeMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 関連取引IDに紐づくフィルタ情報を取得する
         * @param {string} baseBusinessId 関連取引ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterItemsForCustomerForecastTimeline: async (baseBusinessId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseBusinessId' is not null or undefined
            assertParamExists('getFilterItemsForCustomerForecastTimeline', 'baseBusinessId', baseBusinessId)
            const localVarPath = `/customer-forecast/timeline/filter-items/{base_business_id}`
                .replace(`{${"base_business_id"}}`, encodeURIComponent(String(baseBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 指定した期間の客先内示情報を取得する
         * @param {number} targetStartYear 対象開始年
         * @param {number} targetStartMonth 対象開始月
         * @param {number} targetEndYear 対象終了年
         * @param {number} targetEndMonth 対象終了月
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} [filterItem] フィルター対象の項目と情報 (aggregateBusinessIdを含むJSON文字列)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLongTermCustomerForecast: async (targetStartYear: number, targetStartMonth: number, targetEndYear: number, targetEndMonth: number, limit: number, offset: number, filterItem?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetStartYear' is not null or undefined
            assertParamExists('getLongTermCustomerForecast', 'targetStartYear', targetStartYear)
            // verify required parameter 'targetStartMonth' is not null or undefined
            assertParamExists('getLongTermCustomerForecast', 'targetStartMonth', targetStartMonth)
            // verify required parameter 'targetEndYear' is not null or undefined
            assertParamExists('getLongTermCustomerForecast', 'targetEndYear', targetEndYear)
            // verify required parameter 'targetEndMonth' is not null or undefined
            assertParamExists('getLongTermCustomerForecast', 'targetEndMonth', targetEndMonth)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getLongTermCustomerForecast', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getLongTermCustomerForecast', 'offset', offset)
            const localVarPath = `/customer-forecast/longterm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (targetStartYear !== undefined) {
                localVarQueryParameter['target-start-year'] = targetStartYear;
            }

            if (targetStartMonth !== undefined) {
                localVarQueryParameter['target-start-month'] = targetStartMonth;
            }

            if (targetEndYear !== undefined) {
                localVarQueryParameter['target-end-year'] = targetEndYear;
            }

            if (targetEndMonth !== undefined) {
                localVarQueryParameter['target-end-month'] = targetEndMonth;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (filterItem !== undefined) {
                localVarQueryParameter['filter_item'] = filterItem;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 客先内示テーブルに情報を登録する
         * @param {PostCustomerForecastRequest} postCustomerForecastRequest 登録する客先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomerForecast: async (postCustomerForecastRequest: PostCustomerForecastRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postCustomerForecastRequest' is not null or undefined
            assertParamExists('postCustomerForecast', 'postCustomerForecastRequest', postCustomerForecastRequest)
            const localVarPath = `/customer-forecast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCustomerForecastRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerForecastApi - functional programming interface
 * @export
 */
export const CustomerForecastApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerForecastApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 商品名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetBusinessNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBusinessNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetBusinessNameForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetBusinessNameForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 商品CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetBusinessNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBusinessNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetBusinessNumberForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetBusinessNumberForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 売上先名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetCustomerNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetCustomerNameForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetCustomerNameForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 売上先CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetCustomerNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetCustomerNumberForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetCustomerNumberForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 容量の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetPackageForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPackageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetPackageForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetPackageForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 送り先名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetSalesDestinationNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSalesDestinationNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetSalesDestinationNameForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetSalesDestinationNameForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 送り先CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetSalesDestinationNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSalesDestinationNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetSalesDestinationNumberForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetSalesDestinationNumberForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 仕入先名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetSupplierNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSupplierNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetSupplierNameForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetSupplierNameForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 仕入先CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetSupplierNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSupplierNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetSupplierNumberForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetSupplierNumberForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 担当者名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetUserNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetUserNameForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetUserNameForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 置場名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetWarehouseForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWarehouseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetWarehouseForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetWarehouseForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 置場CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetWarehouseNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWarehouseNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetWarehouseNumberForCustomerForecastTimeline(otherFilterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.bulkGetWarehouseNumberForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 客先内示情報をエクスポートする
         * @param {ExportCustomerForecastRequest} exportCustomerForecastRequest エクスポートする客先内示情報のリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCustomerForecast(exportCustomerForecastRequest: ExportCustomerForecastRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportCustomerForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportCustomerForecast(exportCustomerForecastRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.exportCustomerForecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 内示正答率情報をエクスポートする
         * @param {ExportCustomerForecastRateRequest} exportCustomerForecastRateRequest エクスポートする内示正答率情報のリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCustomerForecastRate(exportCustomerForecastRateRequest: ExportCustomerForecastRateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportCustomerForecastRateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportCustomerForecastRate(exportCustomerForecastRateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.exportCustomerForecastRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 一意な関連取引IDをフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineRequiredFilterItem} filterItems フィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBaseBusinessIdForCustomerForecastTimeline(filterItems: CustomerForecastTimelineRequiredFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBaseBusinessIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBaseBusinessIdForCustomerForecastTimeline(filterItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.getBaseBusinessIdForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 客先内示情報テーブルから情報の取得を行う
         * @param {GetCustomerForecastSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} receiveYear 客先内示受領年
         * @param {number} receiveMonth 客先内示受領月
         * @param {CustomerForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
         * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerForecast(sortType: GetCustomerForecastSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, filterItem?: CustomerForecastFilterItem, unassignedResponsibleUserFlag?: boolean, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerForecast(sortType, limit, offset, receiveYear, receiveMonth, filterItem, unassignedResponsibleUserFlag, sortTarget, sortTargetYear, sortTargetMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.getCustomerForecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 内示前月差異情報を取得する
         * @param {GetCustomerForecastDiffLastMonthSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} receiveYear 客先内示受領年
         * @param {number} receiveMonth 客先内示受領月
         * @param {CustomerForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
         * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerForecastDiffLastMonth(sortType: GetCustomerForecastDiffLastMonthSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, filterItem?: CustomerForecastFilterItem, unassignedResponsibleUserFlag?: boolean, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerForecastDiffLastMonthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerForecastDiffLastMonth(sortType, limit, offset, receiveYear, receiveMonth, filterItem, unassignedResponsibleUserFlag, sortTarget, sortTargetYear, sortTargetMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.getCustomerForecastDiffLastMonth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 内示正答率情報を取得する
         * @param {GetCustomerForecastRateSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} receiveYear 客先内示受領年
         * @param {number} receiveMonth 客先内示受領月
         * @param {number} displayMonths 表示月数（3-24の範囲）
         * @param {string} [forecastForReceiptResponsibleUserId] 受領用内示担当者ID
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
         * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerForecastRate(sortType: GetCustomerForecastRateSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, displayMonths: number, forecastForReceiptResponsibleUserId?: string, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerForecastRateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerForecastRate(sortType, limit, offset, receiveYear, receiveMonth, displayMonths, forecastForReceiptResponsibleUserId, sortTarget, sortTargetYear, sortTargetMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.getCustomerForecastRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 客先内示遍歴の情報を取得する
         * @param {string} baseBusinessId 関連取引ID
         * @param {number} startYear 表示開始年
         * @param {number} startMonth 表示開始月
         * @param {number} rangeMonth 表示する月の範囲
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerForecastTimeline(baseBusinessId: string, startYear: number, startMonth: number, rangeMonth: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerForecastTimelineResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerForecastTimeline(baseBusinessId, startYear, startMonth, rangeMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.getCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 関連取引IDに紐づくフィルタ情報を取得する
         * @param {string} baseBusinessId 関連取引ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilterItemsForCustomerForecastTimeline(baseBusinessId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFilterItemsForCustomerForecastTimelineResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilterItemsForCustomerForecastTimeline(baseBusinessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.getFilterItemsForCustomerForecastTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 指定した期間の客先内示情報を取得する
         * @param {number} targetStartYear 対象開始年
         * @param {number} targetStartMonth 対象開始月
         * @param {number} targetEndYear 対象終了年
         * @param {number} targetEndMonth 対象終了月
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} [filterItem] フィルター対象の項目と情報 (aggregateBusinessIdを含むJSON文字列)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLongTermCustomerForecast(targetStartYear: number, targetStartMonth: number, targetEndYear: number, targetEndMonth: number, limit: number, offset: number, filterItem?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLongTermCustomerForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLongTermCustomerForecast(targetStartYear, targetStartMonth, targetEndYear, targetEndMonth, limit, offset, filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.getLongTermCustomerForecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 客先内示テーブルに情報を登録する
         * @param {PostCustomerForecastRequest} postCustomerForecastRequest 登録する客先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCustomerForecast(postCustomerForecastRequest: PostCustomerForecastRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCustomerForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCustomerForecast(postCustomerForecastRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerForecastApi.postCustomerForecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerForecastApi - factory interface
 * @export
 */
export const CustomerForecastApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerForecastApiFp(configuration)
    return {
        /**
         * 
         * @summary 商品名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetBusinessNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetBusinessNameResponse> {
            return localVarFp.bulkGetBusinessNameForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 商品CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetBusinessNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetBusinessNumberResponse> {
            return localVarFp.bulkGetBusinessNumberForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 売上先名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetCustomerNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetCustomerNameResponse> {
            return localVarFp.bulkGetCustomerNameForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 売上先CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetCustomerNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetCustomerNumberResponse> {
            return localVarFp.bulkGetCustomerNumberForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 容量の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetPackageForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetPackageResponse> {
            return localVarFp.bulkGetPackageForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 送り先名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSalesDestinationNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetSalesDestinationNameResponse> {
            return localVarFp.bulkGetSalesDestinationNameForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 送り先CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSalesDestinationNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetSalesDestinationNumberResponse> {
            return localVarFp.bulkGetSalesDestinationNumberForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 仕入先名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSupplierNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetSupplierNameResponse> {
            return localVarFp.bulkGetSupplierNameForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 仕入先CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSupplierNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetSupplierNumberResponse> {
            return localVarFp.bulkGetSupplierNumberForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 担当者名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetUserNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetUserNameResponse> {
            return localVarFp.bulkGetUserNameForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 置場名の選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetWarehouseForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetWarehouseResponse> {
            return localVarFp.bulkGetWarehouseForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 置場CDの選択肢を他のフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetWarehouseNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: any): AxiosPromise<GetWarehouseNumberResponse> {
            return localVarFp.bulkGetWarehouseNumberForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 客先内示情報をエクスポートする
         * @param {ExportCustomerForecastRequest} exportCustomerForecastRequest エクスポートする客先内示情報のリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCustomerForecast(exportCustomerForecastRequest: ExportCustomerForecastRequest, options?: any): AxiosPromise<ExportCustomerForecastResponse> {
            return localVarFp.exportCustomerForecast(exportCustomerForecastRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 内示正答率情報をエクスポートする
         * @param {ExportCustomerForecastRateRequest} exportCustomerForecastRateRequest エクスポートする内示正答率情報のリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCustomerForecastRate(exportCustomerForecastRateRequest: ExportCustomerForecastRateRequest, options?: any): AxiosPromise<ExportCustomerForecastRateResponse> {
            return localVarFp.exportCustomerForecastRate(exportCustomerForecastRateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 一意な関連取引IDをフィルタ情報から絞り込んで取得する
         * @param {CustomerForecastTimelineRequiredFilterItem} filterItems フィルタ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseBusinessIdForCustomerForecastTimeline(filterItems: CustomerForecastTimelineRequiredFilterItem, options?: any): AxiosPromise<GetBaseBusinessIdResponse> {
            return localVarFp.getBaseBusinessIdForCustomerForecastTimeline(filterItems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 客先内示情報テーブルから情報の取得を行う
         * @param {GetCustomerForecastSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} receiveYear 客先内示受領年
         * @param {number} receiveMonth 客先内示受領月
         * @param {CustomerForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
         * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerForecast(sortType: GetCustomerForecastSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, filterItem?: CustomerForecastFilterItem, unassignedResponsibleUserFlag?: boolean, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options?: any): AxiosPromise<GetCustomerForecastResponse> {
            return localVarFp.getCustomerForecast(sortType, limit, offset, receiveYear, receiveMonth, filterItem, unassignedResponsibleUserFlag, sortTarget, sortTargetYear, sortTargetMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 内示前月差異情報を取得する
         * @param {GetCustomerForecastDiffLastMonthSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} receiveYear 客先内示受領年
         * @param {number} receiveMonth 客先内示受領月
         * @param {CustomerForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
         * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerForecastDiffLastMonth(sortType: GetCustomerForecastDiffLastMonthSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, filterItem?: CustomerForecastFilterItem, unassignedResponsibleUserFlag?: boolean, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options?: any): AxiosPromise<GetCustomerForecastDiffLastMonthResponse> {
            return localVarFp.getCustomerForecastDiffLastMonth(sortType, limit, offset, receiveYear, receiveMonth, filterItem, unassignedResponsibleUserFlag, sortTarget, sortTargetYear, sortTargetMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 内示正答率情報を取得する
         * @param {GetCustomerForecastRateSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} receiveYear 客先内示受領年
         * @param {number} receiveMonth 客先内示受領月
         * @param {number} displayMonths 表示月数（3-24の範囲）
         * @param {string} [forecastForReceiptResponsibleUserId] 受領用内示担当者ID
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
         * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerForecastRate(sortType: GetCustomerForecastRateSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, displayMonths: number, forecastForReceiptResponsibleUserId?: string, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options?: any): AxiosPromise<GetCustomerForecastRateResponse> {
            return localVarFp.getCustomerForecastRate(sortType, limit, offset, receiveYear, receiveMonth, displayMonths, forecastForReceiptResponsibleUserId, sortTarget, sortTargetYear, sortTargetMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 客先内示遍歴の情報を取得する
         * @param {string} baseBusinessId 関連取引ID
         * @param {number} startYear 表示開始年
         * @param {number} startMonth 表示開始月
         * @param {number} rangeMonth 表示する月の範囲
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerForecastTimeline(baseBusinessId: string, startYear: number, startMonth: number, rangeMonth: number, options?: any): AxiosPromise<GetCustomerForecastTimelineResponse> {
            return localVarFp.getCustomerForecastTimeline(baseBusinessId, startYear, startMonth, rangeMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 関連取引IDに紐づくフィルタ情報を取得する
         * @param {string} baseBusinessId 関連取引ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterItemsForCustomerForecastTimeline(baseBusinessId: string, options?: any): AxiosPromise<GetFilterItemsForCustomerForecastTimelineResponse> {
            return localVarFp.getFilterItemsForCustomerForecastTimeline(baseBusinessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 指定した期間の客先内示情報を取得する
         * @param {number} targetStartYear 対象開始年
         * @param {number} targetStartMonth 対象開始月
         * @param {number} targetEndYear 対象終了年
         * @param {number} targetEndMonth 対象終了月
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {string} [filterItem] フィルター対象の項目と情報 (aggregateBusinessIdを含むJSON文字列)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLongTermCustomerForecast(targetStartYear: number, targetStartMonth: number, targetEndYear: number, targetEndMonth: number, limit: number, offset: number, filterItem?: string, options?: any): AxiosPromise<GetLongTermCustomerForecastResponse> {
            return localVarFp.getLongTermCustomerForecast(targetStartYear, targetStartMonth, targetEndYear, targetEndMonth, limit, offset, filterItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 客先内示テーブルに情報を登録する
         * @param {PostCustomerForecastRequest} postCustomerForecastRequest 登録する客先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomerForecast(postCustomerForecastRequest: PostCustomerForecastRequest, options?: any): AxiosPromise<PostCustomerForecastResponse> {
            return localVarFp.postCustomerForecast(postCustomerForecastRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerForecastApi - object-oriented interface
 * @export
 * @class CustomerForecastApi
 * @extends {BaseAPI}
 */
export class CustomerForecastApi extends BaseAPI {
    /**
     * 
     * @summary 商品名の選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetBusinessNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetBusinessNameForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 商品CDの選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetBusinessNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetBusinessNumberForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 売上先名の選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetCustomerNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetCustomerNameForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 売上先CDの選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetCustomerNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetCustomerNumberForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 容量の選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetPackageForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetPackageForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 送り先名の選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetSalesDestinationNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetSalesDestinationNameForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 送り先CDの選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetSalesDestinationNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetSalesDestinationNumberForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 仕入先名の選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetSupplierNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetSupplierNameForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 仕入先CDの選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetSupplierNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetSupplierNumberForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 担当者名の選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetUserNameForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetUserNameForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 置場名の選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetWarehouseForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetWarehouseForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 置場CDの選択肢を他のフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineFilterItem} [otherFilterItems] 他のフィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public bulkGetWarehouseNumberForCustomerForecastTimeline(otherFilterItems?: CustomerForecastTimelineFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).bulkGetWarehouseNumberForCustomerForecastTimeline(otherFilterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 客先内示情報をエクスポートする
     * @param {ExportCustomerForecastRequest} exportCustomerForecastRequest エクスポートする客先内示情報のリクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public exportCustomerForecast(exportCustomerForecastRequest: ExportCustomerForecastRequest, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).exportCustomerForecast(exportCustomerForecastRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 内示正答率情報をエクスポートする
     * @param {ExportCustomerForecastRateRequest} exportCustomerForecastRateRequest エクスポートする内示正答率情報のリクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public exportCustomerForecastRate(exportCustomerForecastRateRequest: ExportCustomerForecastRateRequest, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).exportCustomerForecastRate(exportCustomerForecastRateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 一意な関連取引IDをフィルタ情報から絞り込んで取得する
     * @param {CustomerForecastTimelineRequiredFilterItem} filterItems フィルタ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public getBaseBusinessIdForCustomerForecastTimeline(filterItems: CustomerForecastTimelineRequiredFilterItem, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).getBaseBusinessIdForCustomerForecastTimeline(filterItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 客先内示情報テーブルから情報の取得を行う
     * @param {GetCustomerForecastSortTypeEnum} sortType ソートの種類（asc/desc）
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {number} receiveYear 客先内示受領年
     * @param {number} receiveMonth 客先内示受領月
     * @param {CustomerForecastFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
     * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
     * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
     * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public getCustomerForecast(sortType: GetCustomerForecastSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, filterItem?: CustomerForecastFilterItem, unassignedResponsibleUserFlag?: boolean, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).getCustomerForecast(sortType, limit, offset, receiveYear, receiveMonth, filterItem, unassignedResponsibleUserFlag, sortTarget, sortTargetYear, sortTargetMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 内示前月差異情報を取得する
     * @param {GetCustomerForecastDiffLastMonthSortTypeEnum} sortType ソートの種類（asc/desc）
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {number} receiveYear 客先内示受領年
     * @param {number} receiveMonth 客先内示受領月
     * @param {CustomerForecastFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
     * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
     * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
     * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public getCustomerForecastDiffLastMonth(sortType: GetCustomerForecastDiffLastMonthSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, filterItem?: CustomerForecastFilterItem, unassignedResponsibleUserFlag?: boolean, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).getCustomerForecastDiffLastMonth(sortType, limit, offset, receiveYear, receiveMonth, filterItem, unassignedResponsibleUserFlag, sortTarget, sortTargetYear, sortTargetMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 内示正答率情報を取得する
     * @param {GetCustomerForecastRateSortTypeEnum} sortType ソートの種類（asc/desc）
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {number} receiveYear 客先内示受領年
     * @param {number} receiveMonth 客先内示受領月
     * @param {number} displayMonths 表示月数（3-24の範囲）
     * @param {string} [forecastForReceiptResponsibleUserId] 受領用内示担当者ID
     * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
     * @param {number} [sortTargetYear] 内示情報をソートする際の年を指定するパラメータ
     * @param {number} [sortTargetMonth] 内示情報をソートする際の月を指定するパラメータ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public getCustomerForecastRate(sortType: GetCustomerForecastRateSortTypeEnum, limit: number, offset: number, receiveYear: number, receiveMonth: number, displayMonths: number, forecastForReceiptResponsibleUserId?: string, sortTarget?: string, sortTargetYear?: number, sortTargetMonth?: number, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).getCustomerForecastRate(sortType, limit, offset, receiveYear, receiveMonth, displayMonths, forecastForReceiptResponsibleUserId, sortTarget, sortTargetYear, sortTargetMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 客先内示遍歴の情報を取得する
     * @param {string} baseBusinessId 関連取引ID
     * @param {number} startYear 表示開始年
     * @param {number} startMonth 表示開始月
     * @param {number} rangeMonth 表示する月の範囲
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public getCustomerForecastTimeline(baseBusinessId: string, startYear: number, startMonth: number, rangeMonth: number, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).getCustomerForecastTimeline(baseBusinessId, startYear, startMonth, rangeMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 関連取引IDに紐づくフィルタ情報を取得する
     * @param {string} baseBusinessId 関連取引ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public getFilterItemsForCustomerForecastTimeline(baseBusinessId: string, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).getFilterItemsForCustomerForecastTimeline(baseBusinessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 指定した期間の客先内示情報を取得する
     * @param {number} targetStartYear 対象開始年
     * @param {number} targetStartMonth 対象開始月
     * @param {number} targetEndYear 対象終了年
     * @param {number} targetEndMonth 対象終了月
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {string} [filterItem] フィルター対象の項目と情報 (aggregateBusinessIdを含むJSON文字列)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public getLongTermCustomerForecast(targetStartYear: number, targetStartMonth: number, targetEndYear: number, targetEndMonth: number, limit: number, offset: number, filterItem?: string, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).getLongTermCustomerForecast(targetStartYear, targetStartMonth, targetEndYear, targetEndMonth, limit, offset, filterItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 客先内示テーブルに情報を登録する
     * @param {PostCustomerForecastRequest} postCustomerForecastRequest 登録する客先内示テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerForecastApi
     */
    public postCustomerForecast(postCustomerForecastRequest: PostCustomerForecastRequest, options?: RawAxiosRequestConfig) {
        return CustomerForecastApiFp(this.configuration).postCustomerForecast(postCustomerForecastRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetCustomerForecastSortTypeEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetCustomerForecastSortTypeEnum = typeof GetCustomerForecastSortTypeEnum[keyof typeof GetCustomerForecastSortTypeEnum];
/**
 * @export
 */
export const GetCustomerForecastDiffLastMonthSortTypeEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetCustomerForecastDiffLastMonthSortTypeEnum = typeof GetCustomerForecastDiffLastMonthSortTypeEnum[keyof typeof GetCustomerForecastDiffLastMonthSortTypeEnum];
/**
 * @export
 */
export const GetCustomerForecastRateSortTypeEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetCustomerForecastRateSortTypeEnum = typeof GetCustomerForecastRateSortTypeEnum[keyof typeof GetCustomerForecastRateSortTypeEnum];


